





































































































































































































































































































































































































































































































import { Component } from 'vue-mixin-decorator';
import { Watch } from 'vue-property-decorator';
import _ from 'lodash';
import moment from 'moment';

import { REGISTER_USER_INFO, EXAMINEE_ITEMS } from '@/classification/SessionStorageKey';
import { PASSWORD_LENGTH_MIN, PASSWORD_LENGTH_MAX } from '@/classification/KenteiDefinition';
import * as Message from '@/common/Messages';

import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';

import BirthdaySelect from '@/components/BirthdaySelect.vue';
import PrefectureSelect from '@/components/PrefectureSelect.vue';

import * as StringUtil from '@/common/StringUtil';

import RepositoryFactory from '@/repository/RepositoryFactory';

import RegisterUserInfo from '@/models/account/RegisterUserInfo';
import ExamInfo from '@/models/exam/ExamInfo';
import ExamineeItem from '@/models/examinee/ExamineeItem';

import { Core as YubinBangoCore } from 'yubinbango-core';
import RankGetCondition from '@/models/rank/apiParam/RankGetCondition';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'birthday-select': BirthdaySelect,
      'prefecture-select': PrefectureSelect,
      'e-indicator': IndicatorModal,
    },
  },
)
export default class Entry extends BaseView {
  private isInit = true;

  private isIndicatorDisplay = false;

  private isInvalidToken = false;

  private examInfo = new ExamInfo();

  private examineeItems: ExamineeItem[] = [];

  private registerUserInfo = new RegisterUserInfo();

  private isOnlyRegister = false;

  private AccountRepository = RepositoryFactory.get().account;

  private ExamRepository = RepositoryFactory.get().exam;

  private ExamineeRepository = RepositoryFactory.get().examinee;

  private RankRepository = RepositoryFactory.get().rank;

  private errMsg = {
    loginId: '',
    password: '',
    passwordConfirm: '',
    firstName: '',
    lastName: '',
    name: '',
    firstNameKana: '',
    lastNameKana: '',
    nameKana: '',
    gender: '',
    birthday: '',
    postalCode: '',
    prefecture: '',
    city: '',
    street: '',
    buildingName: '',
    phoneNumber: '',
  };

  private created() {
    const { token, rank } = this.$route.query;
    this.registerUserInfo.token = String(token);

    // Queryパラメータにrankが存在しない場合、会員登録のみ行う
    this.isOnlyRegister = StringUtil.isEmpty(rank);

    // Queryパラメータのランクコードを保持
    if (!this.isOnlyRegister) {
      this.registerUserInfo.examRankCode = String(rank);
    }

    // 仮受験者emailトークン検証APIを呼び出し、Queryパラメータのtokenが有効か確認する
    try {
      this.AccountRepository.emailTokenVerify(String(token)).then((response) => {
        // トークン不正
        if (response.status !== 200) {
          this.isInvalidToken = true;
        }
        this.registerUserInfo.mailAddress = response.data.mail_address;
      }).catch(() => {
        this.isInvalidToken = true;
      });
    } catch (e) {
      this.isInvalidToken = true;
    }
  }

  private async mounted() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const AccountCommonCss = document.createElement('link');
    AccountCommonCss.rel = 'stylesheet';
    AccountCommonCss.href = '/account/css/common.css';
    this.$el.appendChild(AccountCommonCss);

    const EntryCss = document.createElement('link');
    EntryCss.rel = 'stylesheet';
    EntryCss.href = '/account/css/entry.css';
    this.$el.appendChild(EntryCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    this.isIndicatorDisplay = true;

    // 検定情報を取得する
    await this.getExamInfo();

    // 検定ランク情報を取得する
    if (!this.isOnlyRegister) {
      await this.getExamRankInfo();
    }

    // 受験者属性を取得
    // SessionStorageに情報がない場合のみ取得
    if (sessionStorage.getItem(EXAMINEE_ITEMS) === null) {
      await this.getExamineeOptionItem();
    }

    // SessionStorageから入力情報を復元
    this.restorationUserInfo();
    this.restorationExamineeItems();

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);

    this.isInit = false;
    this.isIndicatorDisplay = false;
  }

  /**
   * 検定情報を取得する
   */
  private async getExamInfo() {
    try {
      await this.ExamRepository.getExam().then((response) => {
        this.examInfo.examTitle = response.data.exam_title;
        this.examInfo.useNameFlg = response.data.use_name_flg;
        this.examInfo.useNameKanaFlg = response.data.use_name_kana_flg;
        this.examInfo.useGenderFlg = response.data.use_gender_flg;
        this.examInfo.useAddressFlg = response.data.use_address_flg;
        this.examInfo.useMailAnnounceFlg = response.data.use_mail_announce_flg;
      }).catch(() => {
        this.$router.replace(this.paths.TOP);
      });
    } catch (e) {
      this.$router.replace(this.paths.TOP);
    }
  }

  /**
   * 検定ランク情報を取得する
   */
  private async getExamRankInfo() {
    try {
      const rankCode: string = StringUtil.isEmpty(this.registerUserInfo.examRankCode)
        ? '' : String(this.registerUserInfo.examRankCode);
      const rankGetCondition = new RankGetCondition();
      rankGetCondition.needFee = true;

      await this.RankRepository.getRankInfo(rankCode, rankGetCondition).then((response) => {
        if (response.status === 200) {
          this.examInfo.paymentType = response.data.exam_fee_type;
        }
      }).catch(() => {
        this.$router.replace(this.paths.TOP);
      });
    } catch (e) {
      this.$router.replace(this.paths.TOP);
    }
  }

  /**
   * 受験者属性を取得する
   */
  private async getExamineeOptionItem() {
    try {
      await this.ExamineeRepository.getExamineeItems().then((response) => {
        if (response.status === 200) {
          const items = response.data.option_items;
          items.forEach((object: any) => {
            const item = new ExamineeItem();
            object.choices.forEach((choice: any) => {
              item.choices.push({
                displayName: choice.display_name,
                value: choice.value,
              });
            });
            item.optionItemCode = object.option_item_code;
            item.optionItemTitle = object.option_item_title;
            item.inputType = object.input_type;
            item.isRequired = object.is_required;
            item.format = object.format;
            this.examineeItems.push(item);
          });
        }
      }).catch(() => {
        this.$router.replace(this.paths.TOP);
      });
    } catch (e) {
      this.$router.replace(this.paths.TOP);
    }
  }

  /**
   * SessionStageから入力情報を復元します。
   * パスワードは復元しません。
   */
  private restorationUserInfo() {
    if (sessionStorage.getItem(REGISTER_USER_INFO) === null) return;

    const json = JSON.parse(String(sessionStorage.getItem(REGISTER_USER_INFO)));
    this.registerUserInfo.userId = json.userId;
    this.registerUserInfo.password = undefined;
    this.registerUserInfo.passwordConfirm = undefined;
    this.registerUserInfo.firstName = json.firstName;
    this.registerUserInfo.lastName = json.lastName;
    this.registerUserInfo.firstNameKana = json.firstNameKana;
    this.registerUserInfo.lastNameKana = json.lastNameKana;
    this.registerUserInfo.gender = json.gender;
    this.registerUserInfo.birthYear = json.birthYear;
    this.registerUserInfo.birthMonth = json.birthMonth;
    this.registerUserInfo.birthDate = json.birthDate;
    this.registerUserInfo.postalCode = json.postalCode;
    this.registerUserInfo.prefecture = json.prefecture;
    this.registerUserInfo.city = json.city;
    this.registerUserInfo.street = json.street;
    this.registerUserInfo.buildingName = json.buildingName;
    this.registerUserInfo.phoneNumber01 = json.phoneNumber01;
    this.registerUserInfo.phoneNumber02 = json.phoneNumber02;
    this.registerUserInfo.phoneNumber03 = json.phoneNumber03;
    this.registerUserInfo.isReceiveMailAnnounce = json.isReceiveMailAnnounce;
    this.registerUserInfo.examRankCode = json.examRankCode;

    sessionStorage.removeItem(REGISTER_USER_INFO);
  }

  /**
   * SessionStageからオプション項目を復元します。
   */
  private restorationExamineeItems() {
    if (sessionStorage.getItem(EXAMINEE_ITEMS) === null) return;

    const json = JSON.parse(String(sessionStorage.getItem(EXAMINEE_ITEMS)));
    json.forEach((object: any) => {
      const item = new ExamineeItem();
      item.choices = object.choices;
      item.optionItemCode = object.optionItemCode;
      item.optionItemTitle = object.optionItemTitle;
      item.inputType = object.inputType;
      item.isRequired = object.isRequired;
      item.format = object.format;
      item.value = object.value;
      item.values = object.values;
      this.examineeItems.push(item);
    });
    sessionStorage.removeItem(EXAMINEE_ITEMS);
  }

  /**
   * 入力された項目が登録可能か判定し、登録可能な場合、内容確認画面に遷移します。
   */
  private async registerConfirm() {
    this.resetErrorMessage();
    const hasDefaultError = await this.validateDefaultItems();
    const hasOptionError = this.validateOptionItems();

    // 通常・オプションいずれかの項目にエラーあり
    if (hasDefaultError || hasOptionError) return;

    // オプション項目 確認画面表示用のDisplayNameを生成
    this.examineeItems.forEach((item: ExamineeItem) => {
      if (item.inputType === 'checkbox') {
        item.values.forEach((value: string) => {
          item.choices.forEach((choice: any) => {
            if (choice.value === value) {
              item.displayNames.push(choice.displayName);
            }
          });
        });
      }

      if (item.inputType === 'radio') {
        item.choices.forEach((choice: any) => {
          if (choice.value === item.value) {
            item.setDisplayName(choice.displayName);
          }
        });
      }

      if (item.inputType === 'combo') {
        item.choices.forEach((choice: any) => {
          if (choice.displayName === item.value.trim()) {
            item.setDisplayName(choice.displayName);
          }
        });
      }
    });

    // SessionStorageにjson文字列として入力項目を追加
    sessionStorage.setItem(REGISTER_USER_INFO, JSON.stringify(this.registerUserInfo));
    sessionStorage.setItem(EXAMINEE_ITEMS, JSON.stringify(this.examineeItems));
    this.$router.replace(this.paths.ACCOUNT_CONFIRM);
  }

  /**
   * 通常項目のValidateを行います。
   */
  private async validateDefaultItems() {
    await this.validateUserId();
    this.validatePassword();
    this.validatePasswordConfirm();
    this.validateGender();
    this.validateName();
    this.validateNameKana();
    this.validateBirthday();
    this.validateAddress();
    this.validatePhoneNumber();

    let isValidateError = false;
    Object.entries(this.errMsg).forEach(([key, value]) => { // eslint-disable-line
      if (!isValidateError) {
        isValidateError = value !== '';
      }
    });
    return isValidateError;
  }

  /**
   * エラーメッセージをリセットします。
   */
  private resetErrorMessage() {
    this.errMsg = {
      loginId: '',
      password: '',
      passwordConfirm: '',
      firstName: '',
      lastName: '',
      name: '',
      firstNameKana: '',
      lastNameKana: '',
      nameKana: '',
      gender: '',
      birthday: '',
      postalCode: '',
      prefecture: '',
      city: '',
      street: '',
      buildingName: '',
      phoneNumber: '',
    };
  }

  /**
   * IDのValidateを行います。
   */
  private async validateUserId() {
    this.isIndicatorDisplay = true;
    await this.isExistsUserId();
    this.isIndicatorDisplay = false;
    if (!StringUtil.isEmpty(this.errMsg.loginId)) {
      return;
    }

    if (StringUtil.isEmpty(this.registerUserInfo.userId)) {
      this.errMsg.loginId = Message.REQUIRED_LOGIN_ID;
      return;
    }

    // undefinedは無くなったのでStringにキャスト
    const userId = String(this.registerUserInfo.userId);

    if (userId.length < 3 || userId.length > 30) {
      this.errMsg.loginId = Message.LOGIN_ID_LENGTH;
      return;
    }

    // 半角英数(小文字)、アンダースコア（_）のみのチェック
    const regexp = new RegExp('^([a-z0-9_]{3,30})$');
    if (!regexp.test(userId)) {
      this.errMsg.loginId = Message.LOGIN_ID_STRING_TYPE;
    }
  }

  /**
   * パスワードのValidateを行います。
   */
  private validatePassword() {
    this.errMsg.password = '';
    if (StringUtil.isEmpty(this.registerUserInfo.password)) {
      this.errMsg.password = Message.REQUIRED_PASSWORD;
      return;
    }
    // undefinedは無くなったのでStringにキャスト
    const password = String(this.registerUserInfo.password);

    if (password.length < PASSWORD_LENGTH_MIN || password.length > PASSWORD_LENGTH_MAX) {
      this.errMsg.password = Message.PASSWORD_LENGTH;
      return;
    }

    const isIncludeUppercase = password.match('[A-Z]') !== null;
    const isIncludeLowercase = password.match('[a-z]') !== null;
    const isIncludeNumericOrSymbol = password.match('[0-9]|[!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~]') !== null;
    const isIncludeDoubleByte = password.match('[^\x01-\x7E]') !== null;
    if (!isIncludeUppercase || !isIncludeLowercase || !isIncludeNumericOrSymbol || isIncludeDoubleByte) {
      this.errMsg.password = Message.PASSWORD_STRING_TYPE;
    }
  }

  /**
   * パスワードのValidateを行います。
   */
  private validatePasswordConfirm() {
    if (StringUtil.isEmpty(this.registerUserInfo.passwordConfirm)) {
      this.errMsg.passwordConfirm = Message.REQUIRED_PASSWORD_CONFIRM;
      return;
    }

    if (String(this.registerUserInfo.password) !== String(this.registerUserInfo.passwordConfirm)) {
      this.errMsg.passwordConfirm = Message.PASSWORD_MISMATCH;
    }
  }

  /**
   * パスワードのValidateを行います。
   */
  private validateGender() {
    if (!this.examInfo.useGenderFlg) return;

    if (StringUtil.isEmpty(this.registerUserInfo.gender)) {
      this.errMsg.gender = Message.REQUIRED_GENDER;
    }
  }

  /**
   * 生年月日のValidateを行います。
   */
  private validateBirthday() {
    if (StringUtil.isEmpty(this.registerUserInfo.birthYear)
      || StringUtil.isEmpty(this.registerUserInfo.birthMonth)
      || StringUtil.isEmpty(this.registerUserInfo.birthDate)) {
      this.errMsg.birthday = Message.REQUIRED_BIRTHDAY;
      return;
    }

    // 存在日チェック
    const info = this.registerUserInfo as any;
    const y = info.birthYear as string;
    const m = info.birthMonth as string;
    const d = info.birthDate as string;
    const birthday = `${y}-${m}-${d}`;
    if (!moment(birthday, 'YYYY-MM-DD').isValid()) {
      this.errMsg.birthday = Message.INVALID_BIRTHDAY;
    }
  }

  /**
   * 氏名のValidateを行います。
   */
  private validateName() {
    if (!this.examInfo.useNameFlg) return;

    if (StringUtil.isEmpty(this.registerUserInfo.lastName)) {
      this.errMsg.lastName = Message.REQUIRED_LAST_NAME;
      // 名の判定もしたいので返さない
    }
    if (StringUtil.isEmpty(this.registerUserInfo.firstName)) {
      this.errMsg.firstName = Message.REQUIRED_FIRST_NAME;
      return;
    }

    const lastName = String(this.registerUserInfo.lastName);
    const firstName = String(this.registerUserInfo.firstName);

    // 無効な文字（簡体字・繁体字、絵文字、機種依存文字）の混入判定
    if (StringUtil.isIncludeInvalidChar(lastName)) {
      this.errMsg.lastName = Message.INCLUDE_INVALID_STRING;
    }

    if (StringUtil.isIncludeInvalidChar(firstName)) {
      this.errMsg.firstName = Message.INCLUDE_INVALID_STRING;
      return;
    }

    const concatName = `${lastName}${firstName}`;
    const isUppercase = new RegExp('^[^ -~｡-ﾟ]*$').test(concatName);
    if (!isUppercase) {
      this.errMsg.name = Message.NAME_STRING_TYPE;
      return;
    }

    if (concatName.length > 20) {
      this.errMsg.name = Message.NAME_LENGTH;
    }
  }

  /**
   * 氏名カナのValidateを行います。
   */
  private validateNameKana() {
    if (!this.examInfo.useNameKanaFlg) return;

    if (StringUtil.isEmpty(this.registerUserInfo.lastNameKana)) {
      this.errMsg.lastNameKana = Message.REQUIRED_LAST_NAME_KANA;
      // 名の判定もしたいので返さない
    }
    if (StringUtil.isEmpty(this.registerUserInfo.firstNameKana)) {
      this.errMsg.firstNameKana = Message.REQUIRED_FIRST_NAME_KANA;
      return;
    }

    const lastNameKana = String(this.registerUserInfo.lastNameKana);
    const firstNameKana = String(this.registerUserInfo.firstNameKana);
    const concatNameKana = `${lastNameKana}${firstNameKana}`;
    const isUppercase = new RegExp('^[^ -~｡-ﾟ]*$').test(concatNameKana);
    const isKana = new RegExp('^[ァ-ヶー　]+$').test(concatNameKana);

    if (!isUppercase || !isKana) {
      this.errMsg.nameKana = Message.NAME_KANA_STRING_TYPE;
      return;
    }

    if (concatNameKana.length > 20) {
      this.errMsg.nameKana = Message.NAME_KANA_LENGTH;
    }
  }

  /**
   * 住所と電話番号のValidateを行います。
   */
  private validateAddress() {
    if (!this.examInfo.useAddressFlg) return;

    if (StringUtil.isEmpty(this.registerUserInfo.postalCode)) {
      this.errMsg.postalCode = Message.REQUIRED_POSTAL_CODE;
    } else {
      const postalCode = String(this.registerUserInfo.postalCode);
      const isNumeric = postalCode.match('[^0-9]') === null;
      if (!isNumeric) {
        this.errMsg.postalCode = Message.POSTAL_CODE_STRING_TYPE;
      } else if (postalCode.length > 7) {
        this.errMsg.postalCode = Message.POSTAL_CODE_LENGTH;
      }
    }

    if (StringUtil.isEmpty(this.registerUserInfo.prefecture)) {
      this.errMsg.prefecture = Message.REQUIRED_PREFECTURE;
    } else {
      const prefecture = String(this.registerUserInfo.prefecture);
      if (prefecture.length > 4) {
        this.errMsg.prefecture = Message.PREFECTURE_LENGTH;
      }
    }

    if (StringUtil.isEmpty(this.registerUserInfo.city)) {
      this.errMsg.city = Message.REQUIRED_CITY;
    } else {
      const city = String(this.registerUserInfo.city);
      if (city.length > 255) {
        this.errMsg.city = Message.CITY_LENGTH;
      }
    }

    if (StringUtil.isEmpty(this.registerUserInfo.street)) {
      this.errMsg.street = Message.REQUIRED_STREET;
    } else {
      const street = String(this.registerUserInfo.street);
      if (street.length > 255) {
        this.errMsg.street = Message.STREET_LENGTH;
      }
    }

    const buildingName = String(this.registerUserInfo.buildingName);
    if (buildingName.length > 255) {
      this.errMsg.buildingName = Message.BUILDING_NAME_LENGTH;
    }
  }

  /**
   * 電話番号のValidateを行います。
   */
  private validatePhoneNumber() {
    if (!this.examInfo.useAddressFlg) return;

    if (StringUtil.isEmpty(this.registerUserInfo.phoneNumber01)
    || StringUtil.isEmpty(this.registerUserInfo.phoneNumber02)
    || StringUtil.isEmpty(this.registerUserInfo.phoneNumber03)) {
      this.errMsg.phoneNumber = Message.REQUIRED_PHONE_NUMBER;
      return;
    }

    const phone01 = String(this.registerUserInfo.phoneNumber01);
    const phone02 = String(this.registerUserInfo.phoneNumber02);
    const phone03 = String(this.registerUserInfo.phoneNumber03);
    const concatPhoneNumber = `${phone01}${phone02}${phone03}`;

    const isNumeric = concatPhoneNumber.match('[^0-9]') === null;
    if (!isNumeric) {
      this.errMsg.phoneNumber = Message.PHONE_NUMBER_STRING_TYPE;
      return;
    }

    if (phone01.length > 4 || phone02.length > 4 || phone03.length > 4) {
      this.errMsg.phoneNumber = Message.PHONE_NUMBER_LENGTH;
    }
  }

  /**
   * オプション項目のValidateを行います。
   */
  private validateOptionItems() {
    this.examineeItems.forEach((item, index, array) => { // eslint-disable-line
      item.setIsValidateFail(false);
      item.setValidateMessage('');
      if (item.isRequired) {
        if (item.inputType === 'checkbox') {
          item.setIsValidateFail(item.values.length === 0);
        } else {
          item.setIsValidateFail(StringUtil.isEmpty(item.value));
        }

        if (item.isValidateFail) {
          if (Entry.isSelectType(String(item.inputType))) {
            item.setValidateMessage(`${item.optionItemTitle}${Message.TEMPLATE_REQUIRED_SELECT}`);
          } else {
            item.setValidateMessage(`${item.optionItemTitle}${Message.TEMPLATE_REQUIRED_INPUT}`);
          }
          return;
        }
      }

      // 入力形式の場合文字数チェック
      if (item.inputType === 'text' || item.inputType === 'area') {
        if (!StringUtil.isEmpty(item.value) && item.value.length > 500) {
          item.setIsValidateFail(true);
          item.setValidateMessage(Message.generateLengthMessage(String(item.optionItemTitle), '500文字以下'));
        }
      }
    });

    return this.examineeItems.some((item) => item.isValidateFail);
  }

  @Watch('registerUserInfo.userId')
  onTextChanged(newText: string, oldText: string) { // eslint-disable-line
    this.registerUserIdChanged();
  }

  /** ID項目の入力が1秒なかった場合、UserIdの存在チェックを行います。 */
  private registerUserIdChanged = _.debounce(() => this.isExistsUserId(), 1000, {});

  /**
   * this.registerUserInfo.userIdにバインドされたuserIdが登録されているか確認します。
   */
  private async isExistsUserId() {
    this.errMsg.loginId = '';
    if (StringUtil.isEmpty(this.registerUserInfo.userId)) return;

    try {
      const AccountRepository = RepositoryFactory.get().account;
      const userId = String(this.registerUserInfo.userId);
      await AccountRepository.userIdValidation(userId).then((response) => {
        // 200の場合、使用可能
      }).catch((err) => {
        if (!StringUtil.isEmpty(err.response.data.error)) {
          this.errMsg.loginId = Message.EXISTS_ID;
        }
      });
    } catch (e) {
      this.$router.replace('/');
    }
  }

  /**
   * 郵便番号から住所を取得します。
   */
  getAddressFromPostalCode() {
    const { postalCode } = this.registerUserInfo;
    if (StringUtil.isEmpty(postalCode)) return;

    this.registerUserInfo.prefecture = '';
    this.registerUserInfo.city = '';
    this.registerUserInfo.street = '';
    this.registerUserInfo.buildingName = '';

    // eslint-disable-next-line no-new
    new YubinBangoCore(String(postalCode), (addr: any) => {
      this.registerUserInfo.prefecture = addr.region;
      this.registerUserInfo.city = addr.locality;
      this.registerUserInfo.street = addr.street;
    });
  }

  /**
   * 生年月日（年）を設定します。
   * BirthdaySelectのEmitとして呼ばれます。
   *
   * @param year yyyyの文字列
   */
  private setBirthYear(year: string) {
    this.registerUserInfo.birthYear = year;
  }

  /**
   * 生年月日（月）を設定します。
   * BirthdaySelectのEmitとして呼ばれます。
   *
   * @param month MMの文字列
   */
  private setBirthMonth(month: string) {
    this.registerUserInfo.birthMonth = month;
  }

  /**
   * 生年月日（日）を設定します。
   * BirthdaySelectのEmitとして呼ばれます。
   *
   * @param date ddの文字列
   */
  private setBirthDate(date: string) {
    this.registerUserInfo.birthDate = date;
  }

  /**
   * 都道府県を設定します。
   * PrefectureSelectのEmitとして呼ばれます。
   *
   * @param prefecture 都道府県名
   */
  private setPrefecture(prefecture: string) {
    this.registerUserInfo.prefecture = prefecture;
  }

  /**
   * 入力タイプが選択型か判定します。
   *
   * @param inputType 入力タイプ
   */
  static isSelectType(inputType: string) {
    return (inputType === 'checkbox' || inputType === 'radio' || inputType === 'combo');
  }
}
